import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const getAllLots = async (filters, page, size) => {
  try {
    const response = await api.get(`/lot`, {
      headers: setAuthHeader(),
      params: {
        ...filters,
        page,
        size,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao se comunicar com a API.');
  }
};

export const createLot = async (lotData) => {
  try {
    const response = await api.post('/lot', lotData, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error creating lot');
  }
};

export const getLotData = async (lotId) => {
  try {
    const response = await api.get(`/lot/${lotId}`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar dados do lote.');
  }
};

export const updateLot = async (lotId, data) => {
  try {
    const response = await api.put(`/lot/${lotId}`, data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao atualizar o lote.');
  }
};